import { Children, cloneElement, PropsWithChildren, ReactElement } from 'react'
import { cn } from '../../utils'

interface Props {
  label: string
  prop: string
  description?: string
  required?: boolean
  error?: unknown
  register: unknown
  className?: string
}

export function FormItem({
  label,
  error,
  required,
  description,
  children,
  className = '',
  register,
}: PropsWithChildren<Props>) {
  return (
    <div className={cn('flex-y gap-y-2 font-medium', className)}>
      <p className="form-item-label mt-0 text-2xl">
        {label}
        {required && '*'}
      </p>
      {children &&
        Children.map(children, (child) => {
          if (child) {
            return cloneElement(child as ReactElement<{ 'data-error': string }>, {
              'data-error': error ? 'true' : undefined,
              ...(register! as object),
              ...(child as ReactElement).props!,
            })
          }
          return child
        })}
      {description && <p className="form-item-description text-base text-white/60">{description}</p>}
    </div>
  )
}
